import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "mb-2 col-md-" + _vm.colSize },
    [
      _c(VSelect, {
        attrs: {
          label: _vm.label,
          items: _vm.items,
          "item-text": _vm.labelKey,
          "item-value": _vm.valueKey,
          disabled: _vm.disabled,
          multiple: _vm.multiple,
          rules: _vm.rules,
          filled: _vm.disabled,
          outlined: !_vm.disabled,
          dense: "",
          clearable: "",
          "hide-details": "auto",
        },
        on: { change: _vm.handleChange },
        model: {
          value: _vm.internalValue,
          callback: function ($$v) {
            _vm.internalValue = $$v
          },
          expression: "internalValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }